import React, { type ReactNode } from 'react';
import type { RouterActionsType } from '../router-store/types.tsx';
import { useRouterActions } from '../use-router-actions/index.tsx';

type RouterActionsProps = {
	children: (actions: RouterActionsType) => ReactNode;
};

export const RouterActions = ({ children }: RouterActionsProps) => {
	const actions = useRouterActions();

	return <>{children(actions)}</>;
};

RouterActions.displayName = 'RouterActions';
